export const importStatus = {
    error: 'error',
    success: 'success',
    empty: 'empty',
    warning: 'warning',
    importing: 'importing',
    ready: 'ready',
    uploading: 'uploading'
}